<template>
  <div>
    <b-row>
      <template v-if="$route.name == 'leaderAdd'">
        <b-form-group
            v-if="activeLeaders"
            id="input-leader-members"
            :label="$t('leaders.member')"
            label-for="input-members"
            label-align="left"
            class="col-4"
        >
          <v-select
              :options="activeLeaders"
              placeholder=""
              :clearable='false'
              label="fullName"
              v-model="license.member"
              @input="getMemberById"
              class="bg-white rounded"
          >
            <template #no-options="{ }">
              {{ $t("leaders.noMembers") }}
            </template>

          </v-select>
        </b-form-group>
      </template>
      <template v-else > 
        <b-form-group
            
            id="input-member-name"
            :label="$t('leaders.member')"
            label-for="input-member-name"
            label-align="left"
            class="col-4"
        >
          <b-form-input
              id="input-member-name"
              type="text"
              v-model="membersName"
              disabled
              placeholder=""
          ></b-form-input>
        </b-form-group>
      </template>
      <b-form-group
          id="input-member-id"
          :label="$t('leaders.memberId')"
          label-for="input-member-id"
          label-align="left"
          class="col-2"
      >
        <b-form-input
            id="input-member-id"
            type="number"
            v-model="license.member.id"
            disabled
            placeholder=""
        ></b-form-input>
      </b-form-group>
      <b-form-group
          id="input-member-birthDate"
          :label="$t('leaders.birthDate')"
          label-for="input-member-birthDate"
          label-align="left"
          class="col-2"
      >
        <b-form-input
            id="input-member-birthDate"
            type="date"
            v-model="license.member.birthDate"
            disabled
            placeholder=""
        ></b-form-input>
      </b-form-group>
      <b-form-group
          id="input-member-age"
          :label="$t('leaders.age')"
          label-for="input-member-age"
          label-align="left"
          class="col-1"
      >
        <b-form-input
            id="input-member-age"
            v-model="membersAge"
            disabled
            placeholder=""
        ></b-form-input>
      </b-form-group>
    </b-row>
    <b-row> 
      <b-form-group
          id="input-member-address"
          :label="$t('leaders.address')"
          label-for="input-member-address"
          label-align="left"
          class="col-6"
      >
        <b-form-input
            id="input-member-address"
            type="text"
            v-model="license.member.cinfo.address.street"
            disabled
            placeholder=""
        ></b-form-input>
      </b-form-group>
      <b-form-group
          id="input-member-postalCode"
          :label="$t('leaders.postalCode')"
          label-for="input-member-postalCode"
          label-align="left"
          class="col-2"
      >
        <b-form-input
            id="input-member-postalCode"
            type="text"
            v-model="license.member.cinfo.address.postalCode"
            disabled
            placeholder=""
        ></b-form-input>
      </b-form-group>
      <b-form-group
          id="input-member-city"
          :label="$t('leaders.city')"
          label-for="input-member-city"
          label-align="left"
          class="col-4"
      >
        <b-form-input
            id="input-member-city"
            type="text"
            v-model="license.member.cinfo.address.city"
            disabled
            placeholder=""
        ></b-form-input>
      </b-form-group>
    </b-row>
    <b-row> 
      <b-form-group
          id="input-member-telNo"
          :label="$t('leaders.telNo')"
          label-for="input-member-telNo"
          label-align="left"
          class="col-4"
      >
        <b-form-input
            id="input-member-telNo"
            type="text"
            v-model="license.member.cinfo.telNo"
            disabled
            placeholder=""
        ></b-form-input>
      </b-form-group>
      <b-form-group
          id="input-member-cellNo"
          :label="$t('leaders.cellNo')"
          label-for="input-member-cellNo"
          label-align="left"
          class="col-4"
      >
        <b-form-input
            id="input-member-cellNo"
            type="text"
            v-model="license.member.cinfo.cellNo"
            disabled
            placeholder=""
        ></b-form-input>
      </b-form-group>
      <b-form-group
          id="input-member-email"
          :label="$t('leaders.email')"
          label-for="input-member-email"
          label-align="left"
          class="col-4"
      >
        <b-form-input
            id="input-member-email"
            type="text"
            v-model="license.member.cinfo.email"
            disabled
            placeholder=""
        ></b-form-input>
      </b-form-group>
    </b-row>
    <hr/>
    <label class="float-left font-weight-bold"> {{ $t('leaders.licenses')}}</label>
    <b-table 
      :items="leaderLicenses"
      :fields="licenseFields"
      :sort-by.sync="licenseSortBy"
      :sort-desc.sync="licenseSortDesc"
      responsive
      show-empty
      ref="licensesTable"
      class="mt-2"
      thead-class="esep-blue-bg text-light"
    >      


      <template v-slot:empty="">
        <h6>{{ $t("leaders.emptyLicensesTable") }}</h6>
      </template>
    </b-table>
    <hr />
    <b-row>
      <label class="ml-3 float-left font-weight-bold"> {{ $t('leaders.trainingLicense')}}</label>
    </b-row>
    <b-row>
      <b-form-group
          id="input-license-id"
          :label="$t('leaders.licenseId')"
          label-for="input-license-id"
          label-align="left"
          class="col-lg-1 col-md-2"
      >
        <b-form-input
            id="input-license-id"
            type="number"
            v-model="license.id"
            disabled
            placeholder=""
        ></b-form-input>
      </b-form-group>
      <b-form-group
        id="input-leader-type"
        :label="$t('leaders.leaderType')"
        label-for="leader-type"
        label-align="left"
        class="col-lg-4 col-md-5"
      >
        <b-select
          id="leader-type"
          v-model="license.type" 
          disabled
          :options="licenseTypes">
          >
        </b-select>
      </b-form-group>
      <b-form-group
        id="input-leader-status"
        :label="$t('leaders.leaderStatus')"
        label-for="leader-status"
        label-align="left"
        class="col-lg-2 col-md-3"
      >
        <b-select
          id="leader-type"
          v-model="license.status" 
          :options="licenseStatuses">
          >
        </b-select>
      </b-form-group>
      <b-form-group
          id="input-group-issueDate"
          :label="$t('leaders.issueDate')"
          label-for="issueDate-datepicker"
          label-align="left"
          class="col-lg-2 col-md-3"
      >
        <b-form-datepicker
            id="issueDate-datepicker"
            placeholder="-- / -- / ----"
            v-model="license.issueDate"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
            locale="en-GB"
            class="mb-2"
        >
        </b-form-datepicker>
      </b-form-group>
      <b-form-checkbox
        class="my-auto"
        id="tutor-checkbox"
        v-model="license.tutor"
        name="tutor-checkbox"
      >
        {{ $t('leaders.tutor')}}
      </b-form-checkbox>
    </b-row>
    <b-row>
      <b-form-group
          id="input-leader-categories"
          :label="$t('leaders.categories')"
          label-for="input-categories"
          label-align="left"
          class="col-md-12 col-lg-8"
      >
        <v-select
            :options="categories"
            multiple
            placeholder=""
            :clearable='false'
            label="categoryGR"
            v-model="branches"
            :reduce="cat => cat.category"
            class="bg-white rounded"
        >
        </v-select>
      </b-form-group>
    </b-row>
    <hr/>
    <b-row v-if="availableModules">
      <b-form-group
        id="input-module-add"
        :label="$t('leaders.moduleToAdd')"
        label-for="module-add"
        label-align="left"
        class="col-8"
      >
        <v-select
          id="module-add"
          :options="availableModules"
          placeholder=""
          :clearable='false'
          label="title"
          v-model="moduleToAdd"
          class="bg-white rounded"
        >
          <template #no-options="{ }">
            {{ $t("leader.noModules") }}
          </template>
        </v-select>
      </b-form-group>
      <b-button class="esep-blue-bg ml-auto my-auto mr-3" variant="primary" @click="addModule" :disabled="!moduleToAdd">
        {{ $t("common.add") }}
      </b-button>
    </b-row>
    <b-table 
      :items="modules"
      :fields="moduleFields"
      :sort-by.sync="moduleSortBy"
      :sort-desc.sync="moduleSortDesc"
      :per-page="modulePerPage"
      :current-page="moduleCurrentPage"
      responsive
      show-empty
      ref="modulesTable"
      class="mt-2"
      thead-class="esep-blue-bg text-light"
    >      

      <template v-slot:cell(action)="row">
        <b-button
          size="sm"
          @click="deleteModule(row)"
          variant="transparent"
          v-b-tooltip.hover
          :title="$t('leaders.deleteModule')"
        >
          <b-icon icon="trash" ></b-icon>
        </b-button>
      </template>

      <template v-slot:empty="">
        <h6>{{ $t("leaders.emptyModulesTables") }}</h6>
      </template>

    </b-table>
    <b-row>
      <b-col>
        <b-pagination
          v-model="moduleCurrentPage"
          :total-rows="moduleRows"
          :per-page="modulePerPage"
          align="right"
          aria-controls="modulesTable"
          variant="info"
        ></b-pagination>
      </b-col>
    </b-row>
    <hr />
    <b-button @click="saveLicense" variant="success" class="float-left" v-if="$route.name== 'leaderEdit'">{{
        $t("common.save")
      }}
    </b-button>
    <b-button @click="createLicense" variant="success" class="float-left" :disabled='emptyFields' v-else>{{
        $t("common.submit")
      }}
    </b-button>
  </div>
</template>

<script>
import trainingService from '../../services/training.service';
import {handleApiError} from "../../services/error.service";
import { prettifyDate} from '../../services/utils';

export default {
  computed: {
    membersName() {
      return this.license.member.surName + " " + this.license.member.firstName;
    },
    membersAge: function() {
      let currentDate = new Date();
      let birthDate = new Date(this.license.member.birthDate);
      this.$log.debug(birthDate)
      let difference = currentDate - birthDate;
      let age = Math.floor(difference/31557600000);
      return age
    },
    leaderLicenses() {
      let activeLicenses = [];
      this.license.member.leaderLicenses.forEach(
        license => {
          if(license.status == 'ACTIVE') {
            activeLicenses.push(license);
          }
        }
      )
      return activeLicenses;
    },
    emptyFields() {
      let empty = false;
      if(this.license.member == null || this.license.issueDate == null || !this.branches || this.branches.length < 1) {
        empty = true;
      }
      return empty;
    },
    moduleRows() {
      return this.modules ? this.modules.length : 0 ;
    },
  },
  props: {
    license: Object
  },
  mounted() {
    this.$log.debug(this.license);
    this.license.categories.forEach(category => {
        if(category.category) {
          this.branches.push(category.category)
        } else {
          this.modules.push(category.module)
        }
      }
    )
    this.getActiveLeaders();
    this.getAllModules();
  },
  data() {
    return {
      activeLeaders: null,
      licenseFields: [
        { key: "id", label: "Αρ. Εντολής", sortable: true},
        { key: "title", label: "Καθήκοντα", sortable: true, class: 'text-left', thClass: 'text-center', sortByFormatted: true, formatter: "formatTitle"},
        { key: "dateAssigned", label: "Ημ. Έναρξης", sortable: true, class: 'text-left', thClass: 'text-center', sortByFormatted: true, formatter: "prettifyDate" },
        { key: "dueDate", label: "Ημ. Λήξης", sortable: true, class: 'text-left', thClass: 'text-center', sortByFormatted: true, formatter: "prettifyDate"},
        { key: "orgUnit.name", label: "Κλιμάκιο", sortable: true, class: 'text-left', thClass: 'text-center'},
      ],
      licenseSortBy: '',
      licenseSortDesc: false,
      licenseTypes: [
        { value: "TRAINER", text: this.$t('licenseTypesEnums.TRAINER') },
        { value: "TRAIN_LEADER", text: this.$t('licenseTypesEnums.TRAIN_LEADER') },
        { value: "TRAINER_ASSISTANT", text: this.$t('licenseTypesEnums.TRAINER_ASSISTANT') }
      ],
      licenseStatuses: [
        { value: "PENDING_ACCESSION", text: this.$t('licenseStatusEnums.PENDING_ACCESSION') },
        { value: "ACTIVE", text: this.$t('licenseStatusEnums.ACTIVE') },
        { value: "NOT_ACTIVE", text: this.$t('licenseStatusEnums.NOT_ACTIVE') },  
        { value: "HONORS", text: this.$t('licenseStatusEnums.HONORS') },        
      ],
      categories: [
        { category: "CUBS", categoryGR: this.$t('branchTypeEnums.CUBS')},
        { category: "SCOUTS", categoryGR: this.$t('branchTypeEnums.SCOUTS')},
        { category: "VENTURES", categoryGR: this.$t('branchTypeEnums.VENTURES')},
        { category: "ROVERS", categoryGR: this.$t('branchTypeEnums.ROVERS')},
        { category: "LEADERSHIP", categoryGR: this.$t('branchTypeEnums.LEADERSHIP')},
        { category: "TRAINERS", categoryGR: this.$t('branchTypeEnums.TRAINERS')},
        { category: "SPECIAL", categoryGR: this.$t('branchTypeEnums.SPECIAL')},
        { category: "SEMINARS", categoryGR: this.$t('branchTypeEnums.SEMINARS')},
        { category: "AIRSCOUTS", categoryGR: this.$t('branchTypeEnums.AIRSCOUTS')},
        { category: "SEASCOUTS", categoryGR: this.$t('branchTypeEnums.SEASCOUTS')},
      ],
      branches: [],
      moduleToAdd: null,
      availableModules: null,
      modules: [],
      moduleFields: [
        { key: "title", label: "Ενότητα", sortable: true, class: 'text-left', thClass: 'text-center'},
        { key: "action", label: "Ενέργεια", sortable: false, class: 'action-width' }
      ],
      moduleSortBy: "title",
      moduleSortDesc: false,
      modulePerPage: 10,
      moduleCurrentPage: 1
    }
  },
  methods: {
    formatTitle(title) {
      return this.$t(`licensesEnums.${title}`)
    },
    prettifyDate(stringDate) {
      return prettifyDate(stringDate);
    },
    saveLicense() {
      this.$log.debug(this.license);
      this.$log.debug(this.branches);
      this.$log.debug(this.modules);
      trainingService.updateTrainingLicense(this.license, this.branches, this.modules).then(
        (response) => {
          this.$log.debug(response.data);
          this.$emit('emit-success', this.$t('leaders.licenseUpdated'))
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    createLicense() {
      this.$log.debug(this.license);
      this.$log.debug(this.branches);
      this.$log.debug(this.modules);
      trainingService.issueLeaderLicense(this.license, this.branches, this.modules).then(
        (response) => {
          this.$log.debug(response.data);
          this.$router.push({path: '/leaders'});
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    addModule() {
      this.$log.debug(this.moduleToAdd);
      this.modules.push(this.moduleToAdd);
      this.moduleToAdd = null;
    },
    deleteModule(row) {
      for (let i = 0; i < this.modules.length; i++) {
        if (row.item.id === this.modules[i].id) {
          this.modules.splice(i, 1);
        }
      }
    },
    getActiveLeaders() {
      trainingService.getActiveLeaders().then(
        (response) => {
          this.$log.debug(response.data)
          let temp = [];
          response.data.forEach(trainer => {
            trainer.fullName = trainer.surName + " " + trainer.firstName;
            temp.push(trainer)
          })
          this.$log.debug(temp)
          this.activeLeaders = temp;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    getAllModules() {
      trainingService.getModulesByCriteria(true).then(
        (response) => {
          this.$log.debug("modules")
          this.$log.debug(response.data);
          this.availableModules = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    getMemberById(member) {
      trainingService.getMemberById(member.id).then(
        (response) => {
          this.license.member = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    }
  }
}
</script>

<style>
.action-width {
  width: 13rem;
  max-width: 13rem;
  min-width: 13rem;
}
</style>
